import { BASE_LAB_LEVEL } from './baseLab';
import { VERDANT_STILL_LEVEL } from './expansion1';
import { STARFALL_CONDUIT_LEVEL } from './expansion2';
import { NINJA_KID_LEVEL } from './ninjaKid';
import {
  DIFFICULTY_MODES,
  type DifficultyKey,
  type DifficultyMode,
} from '../balance';
import type { LevelDefinition } from './types';

export const DEFAULT_LEVEL_ID = BASE_LAB_LEVEL.id;

const LEVELS: ReadonlyArray<LevelDefinition> = [BASE_LAB_LEVEL, VERDANT_STILL_LEVEL, STARFALL_CONDUIT_LEVEL, NINJA_KID_LEVEL];
const LEVELS_BY_ID = new Map(LEVELS.map((level) => [level.id, level]));

export function listLevelDefinitions(): ReadonlyArray<LevelDefinition> {
  return LEVELS;
}

/** Throws rather than silently starting a different level for an invalid entitlement/config. */
export function getLevelDefinition(levelId: string): LevelDefinition {
  const level = LEVELS_BY_ID.get(levelId);
  if (level === undefined) throw new Error(`Unknown level id: ${levelId}`);
  return level;
}

/** Content is bundled for offline play, but premium arenas still require a trusted native
 * entitlement before a native run can begin. This is normal access control, not DRM. */
export function isLevelUnlocked(level: LevelDefinition, premium: boolean): boolean {
  return level.entitlement === 'base' || premium;
}

/** Resolve a fresh profile so arena-specific Easy tuning cannot mutate shared constants. */
export function difficultyModeForLevel(
  level: LevelDefinition,
  difficulty: DifficultyKey,
): DifficultyMode {
  return {
    ...DIFFICULTY_MODES[difficulty],
    ...level.difficultyOverrides?.[difficulty],
  };
}

export { BASE_LAB_LEVEL } from './baseLab';
export { VERDANT_STILL_LEVEL } from './expansion1';
export { STARFALL_CONDUIT_LEVEL } from './expansion2';
export { NINJA_KID_LEVEL } from './ninjaKid';
export type { BloomVineTuning, EnemyTierUnlock, GravityRailTuning, LevelDefinition, LevelEntitlement, LevelVisualTheme, SpawnTuning } from './types';
